import React from "react";

import { useTheme } from '@mui/material/styles';

function LogoutIcon() {
    const theme = useTheme();

    const color = theme.palette.icons.color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path d="M4 12h12m0 0-4-4m4 4-4 4m1-14h7v20h-7" stroke={color} />
        </svg>
    )
}

export default LogoutIcon;
